import Router from '@triotech/vue-core/src/plugins/router';
import Store from '@triotech/vue-core/src/plugins/store';
import _ from '@triotech/vue-core/src/plugins/_';
import Moment from '@triotech/vue-core/src/vendor/moment';
import Ajax from './ajax';
import Helper from './helper';

const parametersExpired = () => {
  const { parameters } = Store.state;
  return _.isNil(parameters) || !(parameters.expire && parameters.expire > Number(Moment()));
};

Router.beforeResolve(async (to, from, next) => {
  let promises = [];

  // Custom Firewall
  if (_.isNil(Store.getters.oauth) && to.name !== 'login' && to.name !== 'request' && to.name !== 'resetting' && to.name !== 'smart_login') {
    return next({ name: 'login' });
  }

  if (parametersExpired()) {
    promises.push(Ajax.publicRequest('public/metadata/mon-pcie').then((data) => {
      const { parameters, image } = data;
      Store.commit('set', {
        parameters: {
          can_display_on_verifpcie: _.find(parameters, { label: 'can.display.on.verifpcie' }),
          base_url_verif_pcie: _.find(parameters, { label: 'base.url.verif.pcie' }),
          can_share_on_facebook: _.find(parameters, { label: 'can.share.on.facebook' }),
          company: _.find(parameters, { label: 'company' }),
          player: _.find(parameters, { label: 'player.uri' }),
          show_validated_result: _.find(parameters, { label: 'show.validated.result' }),
          show_language: _.find(parameters, { label: 'show.language' }),
          show_player_demo: _.find(parameters, { label: 'show.player.demo' }),
          show_help_video: _.find(parameters, { label: 'show.video.help' }),
          logo: image && image.upload_file_path,
          expire: Number(Moment().add(1, 'h')),
        },
      });
    }));
  }

  if (_.isNull(from.name)) {
    promises = promises.concat(Helper.getEnums());
  }

  return Promise.all(promises).finally(next);
});
